import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from '../../../../../environments/environment';

const isAdminApiRequest = (url: string): boolean => /\/(api\/)?admin\//.test(url);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (isAdminApiRequest(req.url)) return next(req);

  const token = authService.getAccessToken();

  const authReq = req.clone({
    withCredentials: true,
    ...(token ? { setHeaders: { Authorization: `Bearer ${token}` } } : {}),
  });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        if (router.url.startsWith('/admin')) return throwError(() => error);
        authService.clearSession();
        // Nunca redirigir al /login directamente — el login se inicia en WordPress.
        window.location.href = environment.wordpressUrl;
      }
      return throwError(() => error);
    }),
  );
};
